import { FilterChips } from '@sonnen/web-ui';
import { useEffect, useState } from 'react';
import { useAppContext } from '../../../AppContext/AppContext';
import { LocaleKey, useTranslation } from '../../../i18n/i18n';
import { useOfferContext } from '../../../OfferContext/OfferContext';
import { ModuleName } from '../../../types';
import { ChartLegend } from '../ChartLegend/ChartLegend';
import { EnergyDynamicUSP } from '../EnergyDynamicUSP/EnergyDynamicUSP';
import { MonthlyPriceChart } from '../MonthlyPriceChart/MonthlyPriceChart';
import { QuarterlyPriceCards } from '../QuarterlyPriceCards/QuarterlyPriceCards';
import { QuarterlyPriceChart } from '../QuarterlyPriceChart/QuarterlyPriceChart';
import styles from './ChartsContainer.module.css';

type ChartType = 'today' | 'pastYear';

const TEST_ID = 'charts-container';

export const ChartsContainer = () => {
  const { t } = useTranslation();
  const { modules } = useAppContext();
  const { offer, quarterlyPriceData } = useOfferContext();
  const chartDataPresent = Boolean(quarterlyPriceData);

  const [selectedChart, setSelectedChart] = useState<ChartType>('today');

  useEffect(() => {
    if (!offer) setSelectedChart('today');
  }, [offer]);

  let legend: LocaleKey = 'chart.quarterlyPriceWithEnergyDynamic';

  if (quarterlyPriceData === null) {
    legend = 'home.cardChart.legend';
  } else if (chartDataPresent && selectedChart === 'pastYear') {
    if (
      modules.has(ModuleName.PRICE_OPTIMIZATION) &&
      offer?.energyDynamic?.configurationWithBatteryOptimizationModule
    ) {
      legend = 'chart.monthlyWithPriceOptimizationLegend';
    } else {
      legend = 'chart.monthlyWithoutPriceOptimizationLegend';
    }
  }

  const tabs = [
    {
      value: 'today',
      label: t('chart.today'),
    },
    {
      value: 'pastYear',
      label: t('chart.pastYear'),
    },
  ];

  if (quarterlyPriceData === null) {
    return (
      <>
        <EnergyDynamicUSP />
        <ChartLegend localeKey={legend} />
      </>
    );
  }

  if (typeof quarterlyPriceData === 'undefined') return <div data-testid={TEST_ID} />;

  return (
    <div data-testid={TEST_ID}>
      {selectedChart === 'today' ? (
        <div data-testid="quarterly-price-chart-container">
          <QuarterlyPriceCards />
          <QuarterlyPriceChart />
        </div>
      ) : (
        <MonthlyPriceChart />
      )}

      <div className={styles.chartLabels}>
        <FilterChips
          multiple={false}
          items={tabs}
          onChange={(item) => setSelectedChart(item[0].value as ChartType)}
          stretch
          required
        />
      </div>
      <ChartLegend localeKey={legend} />
    </div>
  );
};
